import { render, staticRenderFns } from "./antetConvocation.vue?vue&type=template&id=641d6178&"
import script from "./antetConvocation.vue?vue&type=script&lang=js&"
export * from "./antetConvocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports